import { createContext, type FC, type ReactNode, useContext } from "react";

const Context = createContext<string | null>(null);

export const PackageRestrictionContext = Context.Provider;

export const ManualPackageRestrictionContext: FC<{ restrictedPackNo: string; children?: ReactNode }> = ({
  restrictedPackNo,
  children,
}) => {
  return <PackageRestrictionContext value={restrictedPackNo}>{children}</PackageRestrictionContext>;
};

export const usePackageRestrictionContext = () => useContext(Context);
